import React from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import RBACSeederPage from './index';

const RBACSeeder = () => {
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/customer/dashboard'}
          routeSegments={[{ name: 'Khởi tạo hệ thống phân quyền' }]}
        />
      </div>
      <RBACSeederPage />
    </ContainerBody>
  );
};

export default compose(withPaginate)(RBACSeeder);
